import { render, staticRenderFns } from "./Example.vue?vue&type=template&id=0ccae235&scoped=true&lang=pug&"
import script from "./Example.vue?vue&type=script&lang=js&"
export * from "./Example.vue?vue&type=script&lang=js&"
import style0 from "./Example.vue?vue&type=style&index=0&id=0ccae235&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccae235",
  null
  
)

export default component.exports